import { Component, signal, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './services/auth.service';

// Import default language translations for immediate availability
import defaultTranslations from '../../public/assets/i18n/en.json';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  private translateService = inject(TranslateService);
  private authService = inject(AuthService);
  protected readonly title = signal('dashboard');

  constructor() {
    // Set the static translations for immediate availability
    this.translateService.setTranslation('en', defaultTranslations);

    // Set the default language - translations are already available
    this.translateService.setFallbackLang('en');
    this.translateService.use('en');
  }

  ngOnInit(): void {
    // Initialize authentication state on app startup
    this.authService.initializeAuth();
  }
}
